export default __webpack_public_path__ + "static/media/how-it-works_03.90267a5f.png";